import { css } from 'styled-components';

import { IVerTaskCard } from './common';

export const TaskBlurbStyles = css<IVerTaskCard>`
  ${props => props.isComplete && `
    display: none;
    color: ${props.theme.colorSlate50};
  `}

  display: flex;
  align-items: center;
  margin-top: 0.25em;
  margin-bottom: 0;
  color: ${({ theme: { taskCard }}) => taskCard.colorSubhead};
`;
